import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import Avatar from "@material-ui/core/Avatar";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import ImageIcon from '@material-ui/icons/Image';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import withStyles from "@material-ui/core/styles/withStyles";
import customImageInputStyle from "./Style";
import classnames from "classnames";
import SaveIcon from '@material-ui/icons/Save';
//import AvatarEditor from 'react-avatar-editor'

class CustomImageInput extends Component {

    constructor(props) {
        super(props);
        this.fileUpload = React.createRef();
        this.showFileUpload = this.showFileUpload.bind(this);
        this.clearFileUpload = this.clearFileUpload.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    state = {
        file: undefined,
        imagePreviewUrl: undefined
    };

    showFileUpload() {
        if (this.fileUpload) {
            this.fileUpload.current.click();
        }
    }

    handleImageChange(e) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                this.setState({
                    file: file,
                    imagePreviewUrl: reader.result
                });
            };
            reader.readAsDataURL(file);
            this.props.setFieldValue(this.props.field.name, file);
        }
    }

    // showPreloadImage2() {
    //     const { errorMessage, classes } = this.props;
    //     const { name } = this.props.field;
    //     const { file, imagePreviewUrl } = this.state;
    //     // if(imagePreviewUrl === undefined)
    //     //     imagePreviewUrl = this.props.sample

    //     let comp = null;

    //     if (errorMessage) {
    //         comp = <Icon style={{ fontSize: 36 }}>error_outline</Icon>;
    //     } else if (file) {
    //         comp = (
    //             <AvatarEditor
    //                 image={imagePreviewUrl}
    //                 width={250}
    //                 height={250}
    //                 border={50}
    //                 color={[255, 255, 255, 0.6]} // RGBA
    //                 scale={1.2}
    //                 rotate={0}
    //             />
    //         );
    //     } else {
    //         comp = <Icon style={{ fontSize: 36 }}>folder</Icon>;
    //     }
    //     return comp;
    // }

    showPreloadImage() {
        const { errorMessage, classes } = this.props;
        const { name } = this.props.field;
        const { file, imagePreviewUrl } = this.state;
        // if(imagePreviewUrl === undefined)
        //     imagePreviewUrl = this.props.sample

        let comp = null;

        if (errorMessage) {
            comp = <Icon style={{ fontSize: 36 }}>error_outline</Icon>;
        } else if (file) {
            comp = (
                <img style={{ borderRadius: '15px' }} className={classes.avatarThumb} src={imagePreviewUrl} alt="..." />
            );
        } else {
            comp = <Icon style={{ fontSize: 36 }}>folder</Icon>;
        }
        return comp;
    }

    clearFileUpload() {

        if (this.fileUpload) {
            this.fileUpload.current.value = '';
            this.setState({
                file: undefined,
                imagePreviewUrl: undefined
            });
        }

    }

    componentDidMount() {
        console.log(this.fileUpload.current);
    }

    render() {

        const { errorMessage, classes, type, noBtn, defaultImage, btnText, btnActivitiy, boxHeight } = this.props;
        const { name, onBlur } = this.props.field;

        const avatarStyle = classnames(
            classes.bigAvatar,
            this.state.file ? [classes.whiteBack] : [classes.primaryBack],
            { [classes.errorBack]: errorMessage }
        );

        return (
            <div className={classes.container}>
                {(typeof this.state.imagePreviewUrl !== "undefined") ? (
                    <Avatar className={avatarStyle} onClick={this.showFileUpload}>
                        {this.showPreloadImage()}"
                    </Avatar>
                ) : (typeof defaultImage !== "undefined" && defaultImage !== null && defaultImage !== '') ? (
                    <img src={defaultImage} style={{ width: '100%', height: '100%' }} />
                ) : (<Box
                    height={boxHeight}
                    bgcolor="#fff"
                    border={`2px dashed ${errorMessage?'#f44336':'#a7a7a7'}`}
                    borderRadius="15px"
                    justifyContent="center"
                    className={classes.box}
                    justifyItems="center"
                    alignItems="center"
                    textAlign="center"
                    style={{ padding: '0px' }}
                    onClick={this.showFileUpload}
                >
                    {(type === "image") ? (
                        <>
                            <ImageIcon style={{ width: '2em', height: '2em' }} />
                        </>
                    ) : (type === "file") ? (
                        <>
                            <FileCopyIcon style={{ width: '2em', height: '2em' }} />
                        </>
                    ) : (
                        <>
                        </>
                    )}
                </Box>)}
                <input
                    className={classes.hidden}
                    id={name}
                    name={name}
                    type="file"
                    onChange={this.handleImageChange}
                    ref={this.fileUpload}
                // onBlur={onBlur}
                //className="form-control"
                />
                <div style={{ textAlign: 'center' }}>
                    <Button type="button" variant="contained" color="primary" onClick={this.showFileUpload} style={{ marginLeft: '20px !important', display: (btnActivitiy) ? 'none' : 'inline-block' }}>انتخاب</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                  {!noBtn && (<Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={btnActivitiy}
                        className={classes.btnSave}
                        style={{ display: (this.state.imagePreviewUrl !== undefined) ? 'inline-block' : 'none' }}
                        startIcon={<SaveIcon style={{ position: 'relative', top: '3px' }} />}>
                        <span style={{ position: 'relative', top: '-2px', marginRight: '7px' }}>{btnText}</span>
                    </Button>)}
                    {/* <Button variant="contained" onClick={this.clearFileUpload} className={classes.buttonClear}>
                        لغو
                    </Button> */}

                </div>


                {(typeof this.state.imagePreviewUrl !== "undefined" && errorMessage) ? (
                    <Typography variant="caption" color="error">
                        {errorMessage}
                    </Typography>
                ) : null}

            </div>
        );
    }

}

export default withStyles(customImageInputStyle)(CustomImageInput);
